(function($) {
	$.fn.inputFilter = function(inputFilter) {
    return this.on("input keydown keyup mousedown mouseup select contextmenu drop focusout", function(e) {
      if (inputFilter(this.value,this)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  };
}(jQuery));
jQuery(document).ready(function ($) {
	/* search */
	$('.calculators #calc-search .search-icon').on('click',function() {
		calcSearch($('#calc-search .js-search-all'), $('#calc-search').parent().find('.js-search-panel'), 'calc_search');
	});
	calcSearch($('#calc-search .js-search-all'), $('#calc-search').parent().find('.js-search-panel'), 'calc_search');
	$('#calc-search').keypress(function(e){
    if(e.which === 13)
      return false;
	});
	function calcSearch(inputSearchField, searchPanel, fn) {
		var minQLen = 2;
		var searchValue;
		var lastValue;
		var $inputSearchField = inputSearchField;
		var lastXhr;
		$inputSearchField.on('change keyup', function (e) {
			searchValue = $inputSearchField.val();
			if (searchValue.length < minQLen)
				return;
			if (searchValue === lastValue)
				return;
			if(lastXhr && lastXhr.readyState < 4)
				lastXhr.abort();
			lastXhr = calcResult(inputSearchField, searchValue, fn, searchPanel);
			lastValue = searchValue;
		});
	}
	function calcResult(input, searchTerm, searchFunction, searchPanel) {
		console.log('searching...');
		var id = $(input).parents('form').attr('id');
		return $.ajax({
			url: localize_calc.ajaxurl,
			dataType: 'html',
			type: 'POST',
			data: {
				'search': searchTerm,
				'action': searchFunction
			},
			success: function (data) {
				$(searchPanel).addClass('js-search-panel-active');
				$(searchPanel).find('.js-search-panel-container').html(data);
				openCalcSearch(id);
			},
			error: function (err) {
				console.log(err);
			}
		});
	}
	function openCalcSearch(id) {
		$('#'+id+' .js-search-all').focus();
		$('#'+id).parent().find('.js-search-panel').addClass('js-search-panel-active');
	}
	/* create custom selects */
	$.createCustom('.calculator form','.calculator form .custom-select','.custom-select');
	$('.calculators').on('click','.calc-select .select-selected',function(e){
		$(this).toggleClass('active');
		$(this).siblings('.select-items').toggleClass('select-hide');
	});
	$(document).on('click', function(e){
		if($('#calc-search').parent().find('.js-search-panel.js-search-panel-active').length > 0) {
			if(!$(e.target).is('.js-search-panel-active') && !$(e.target).parents('.js-search-panel-active').length)
				$('#calc-search').parent().find('.js-search-panel').removeClass('js-search-panel-active');
		}
		if($('.calculators .calc-select').length > 0) {
			if($('.calculators .calc-select').parent().hasClass('js-active-menu')) {
				if(!$('.calculators .calc-select .select-selected').hasClass('active')) {
					$('.calculators .calc-select .select-selected').addClass('active');
				}
				if($('.calculators .calc-select .select-items').hasClass('select-hide')) {
					$('.calculators .calc-select .select-items').removeClass('select-hide');
				}
			} else {
				if(!$(e.target).is('.calc-select') && $(e.target).parents('.calc-select').length == 0 && $(e.target).parents('#calc-search').length == 0) {
					$('.calculators .calc-select .select-items').addClass('select-hide');
					$('.calculators .calc-select .select-selected').removeClass('active');
				}
			}
		}
	});
	$('form[id^="calc["] input[type="text"]').inputFilter(function(value, el) {
		let pattern = $(el).attr('pattern') != '' ? $(el).attr('pattern') : '\d*';
  	let exp = new RegExp('^' + pattern + '$');
		return exp.test(value);
  });
	$(document).on('keyup','form[id^="calc["] input',function(e){
		e.preventDefault();
		let id = $($(e.target).parents('article')[0]).data('id'),
			formid = $(e.target).parents('form')[0].id,
			fields = $('article[data-id="'+id+'"] form[id="'+formid+'"] .field:not(.required)'),
			index = 0;
		$(fields).each(function(i,el){
			if($(el).is($(e.target)))
				index = i;
		});
		calc(id,formid, index);
	});
	$('form[id^="calc["] input[type="checkbox"]').on('click',function(e){
		let id = $($(e.target).parents('article')[0]).data('id'),
			formid = $(e.target).parents('form')[0].id;
		calc(id,formid);
	});
	$('form[id^="calc["] select').on('change',function(e){
		$('form[id^="calc["] input[type="checkbox"]').each(function(i,el){
			if($(el).attr('data-select') == $(e.target).attr('name')) {
				if ($(e.target).val() == $(el).data('option'))
					$($(el).parents('.form-element.checkbox')).css('display','');
				else
					$($(el).parents('.form-element.checkbox')[0]).css('display','none');
			}
		});
		let id = $($(e.target).parents('article')[0]).data('id'),
			formid = $(e.target).parents('form')[0].id;
		calc(id,formid);
	});
	$('form[id^="calc["] input[type="radio"]').on('change',function(e){
		let id = $($(e.target).parents('article')[0]).data('id'),
			formid = $(e.target).parents('form')[0].id;
		calc(id,formid);
	});
	// hide result text if Enhetsomvandlaren
	if($('article form').attr('id') == 'calc[3]') {
		$('.js-result-text').hide();
	}
	/* collect data */
	function calc(id,formid,index=0) {
		if(!localize_calc.logged_in) {
			$('.not_logged').show();
			return;
		}
		$('.not_logged').hide();
		let data = [],
			warnig = '',
			fields = $('article[data-id="'+id+'"] form[id="'+formid+'"] .field'),
			not_required = $('article[data-id="'+id+'"] form[id="'+formid+'"] .field:not(.required)'),
			required = $('article[data-id="'+id+'"] form[id="'+formid+'"] .required'),
			count_required = 0,
			result = '';
		$('article[data-id="'+id+'"] .calc-error').html('');
		$(fields).each(function(i,el){
			$(el).parent().removeClass('required-error');
			if($(el).is('select')) {
				data.push({name:$(el).attr('name'),value:$(el).val()});
			} else if($(el).is(':radio')) {
				if($(el).is(':checked'))
					data.push({name:$(el).attr('name'),value:$(el).val()});
			} else if($(el).is(':checkbox')) {
				if($(el).is(':checked'))
					data.push($(el).attr('name'));
			} else {
				if($(el).val().length > 0) {
					data[i] = $(el).val();
					if($(el).hasClass('required'))
						count_required++;
				} else {
					if($(el).hasClass('required')) {
						$(el).parent().addClass('required-error');
					}
				}
			}
		});
		console.log(data);
		if(required.length > 0 && required.length === count_required) {
			result = getFormula(formid,data);
			if(Array.isArray(result)) {
				if(index === 0)
					$($(not_required)[index+1]).val(isNaN(result[index])?'':(result[index]<0?0:result[index]));
				else
					$($(not_required)[index-1]).val(isNaN(result[index])?'':result[index]);

				if(formid == 'calc[1]') {
					if(index === 0 && !isNaN(result[index])) {
						$('article[data-id="'+id+'"] .calc-result').html('BMI: '+ result[index] + ' kg/m<sup>2</sup>');
					} else if(index !== 0 && !isNaN(result[index])) {
						$('article[data-id="'+id+'"] .calc-result').html('Vikt: '+ result[index] + ' kg');
					}
				}
			} else {
				$('article[data-id="'+id+'"] .calc-result').html(result);
			}
		} else if(required.length === 0 && data.length > 0) {
			result = getFormula(formid,data);
			if(Array.isArray(result)) {
				if(index % 2 == 0)
					$($(not_required)[index+1]).val(isNaN(result[index])?'':(result[index]<0?0:result[index]));
				else
					$($(not_required)[index-1]).val(isNaN(result[index])?'':result[index]);
			} else {
				$('article[data-id="'+id+'"] .calc-result').html(result);
			}
		} else {
			result = $('article[data-id="'+id+'"] .default-result');
			$('article[data-id="'+id+'"] .calc-result').html(result.length>0?result.html():'');
			if(required.length > 0 && required.length !== count_required)
				warnig = 'Vänligen fyll i alla fält.';
			$('article[data-id="'+id+'"] .calc-error').html(warnig);
		}
	}
	const decimalCount = num => {
		const numStr = String(num);
		if (numStr.includes('.'))
			 return numStr.split('.')[1].length;
		return 0;
 	}
	function removeZeros(result) {
		if(result.slice(-1) == '0')
			return removeZeros(result.substring(0, result.length - 1));
		else
			return result;
	}
 	function round(value,precision) {
		let result = value;
		if (/^\d$/.test(value) && Number(value) === value && value % 1 !== 0) {
			let multiplier = Math.pow(10, precision || 0);
			result = parseFloat(Math.round(value * multiplier) / multiplier).toFixed(precision);
			result = removeZeros(result);
		}
		return result;
	}
	/* get results */
	function getFormula(id,data) {
		let result = '',
			ires = 0,
			calculate = ['calc[7]','calc[9]','calc[11]','calc[12]','calc[13]','calc[16]','calc[18]','calc[19]','calc[21]','calc[23]','calc[26]','calc[29]','calc[32]','calc[33]','calc[34]','calc[35]','calc[36]','calc[37]','calc[38]','calc[39]','calc[40]','calc[42]','calc[45]'];
		if(calculate.includes(id))
			result = mapData(id,data);
		if(id == 'calc[25]')
			ires = 1.86 * parseInt(data[0]) + parseFloat(data[1]) + parseFloat(data[2]) + 9;
		if(id == 'calc[27]')
			ires = 4 * parseInt(data[0]) * parseInt(data[1]);
		if(id == 'calc[44]')
			ires = parseInt(data[1])>7?(parseInt(data[1])>60?(parseInt(data[1])>600?(parseInt(data[1])>6000?(parseInt(data[1])>60000?0:1):2):3):4):5;
		let	formulas = {
			'calc[0]': 'Man: '+ Math.round(66.4730 + parseInt(data[1]) * 13.7516 + parseInt(data[0]) * 5.0033 - parseInt(data[2]) * 6.7550) + ' kcal/dygn<br>Kvinna: '+ Math.round(655.0955 + parseInt(data[1]) * 9.5634 + parseInt(data[0]) * 1.8496 - parseInt(data[2]) * 4.6756) + ' kcal/dygn',
			'calc[1]': [
				parseFloat(parseFloat(data[1])/(Math.pow(parseInt(data[0])/100, 2))).toFixed(2),
				parseFloat(parseFloat(data[2])*(Math.pow(parseInt(data[0])/100, 2))).toFixed(2)
			],
			'calc[2]': 'Korrigerat: '+ parseFloat(parseFloat(data[0]) + 0.02 * (40 - parseFloat(data[1]))).toFixed(1) + ' mmol/L',
			'calc[3]': [
				round(parseFloat(data[0])*2.54,2),
				round(parseFloat(data[1])*0.39370079,2),
				round(parseFloat(data[2])*30.48,2),
				round(parseFloat(data[3])*0.0328084,2),
				round(parseFloat(data[4])*0.45359237,2),
				round(parseFloat(data[5])*2.20462262,2),
			],
			'calc[4]': [
				decimalCount(data[0]) === 0 ? Math.round(10.45 * parseFloat(data[0]) - 10.62) : (parseInt(data[0]) < 2 ? (parseFloat(data[0]) < 1.12 ? parseFloat(10.45 * parseFloat(data[0]) - 10.62).toFixed(decimalCount(data[0])+1) : parseFloat(10.45 * parseFloat(data[0]) - 10.62).toFixed(decimalCount(data[0]))) : parseFloat(10.45 * parseFloat(data[0]) - 10.62).toFixed(decimalCount(data[0])-1)),
				parseFloat(0.0957 * parseFloat(data[1]) + 1.016).toFixed(decimalCount(data[1])+1)
			],
			'calc[5]': parseFloat(Math.pow(parseInt(data[0]), 0.725)*Math.pow(parseFloat(data[1]), 0.425)*0.007184).toFixed(2) + ' m<sup>2</sup>',
			'calc[6]': 'LDL: ' + parseFloat(parseFloat(data[0]) - parseFloat(data[1]) - parseFloat(data[2])*0.45).toFixed(2) + ' mmol/L',
			'calc[7]': 'Diagnoser efter sannolikhet<br>'+ result,
			'calc[8]': 'Poäng: '+data.length+'<br>'+(data.length<3?'Inget snabbtest. Symtomatisk behandling vid behov.':'Antibiotika vid positivt snabbtest.'),
			'calc[9]': result,
			'calc[10]': 'GUCI: '+round((parseFloat(data[0]) * parseFloat(data[2]) * 100) / (parseInt(data[3]) * parseFloat(data[1])),2),
			'calc[11]': result,
			'calc[12]': result,
			'calc[13]': 'Poäng: '+result,
			'calc[14]': data.length>1?'Sannolikt behov av massiv transfusion.':'Mindre sannolikt behov av massiv transfusion',
			'calc[15]': parseFloat(data[0]) + parseFloat(data[1]) - parseFloat(data[2]) - parseFloat(data[3]) + ' mmol/L',
			'calc[16]': 'Poäng: '+result,
			'calc[17]': data.length>0?'CT skalle rekommenderas.':'CT skalle behövs inte.',
			'calc[18]': result,
			'calc[19]': result,
			'calc[20]': 'Korrigerat: '+ Math.round(parseInt(data[1]) + 2.4*((parseFloat(data[0]) - 5.6) / 5.6).toFixed(1)) + ' mmol/L',
			'calc[21]': result,
			'calc[22]': 'MAP: ' + Math.round((parseInt(data[0]) + (parseInt(data[1]) * 2)) /3) + ' mmHg',
			'calc[23]': result,
			'calc[24]': data.length>4?'Låg risk för skada: Röntgen krävs inte.':'Risk för skada: Röntga.',
			'calc[25]': (data[3]?'Osmolalitetsgap: '+ Math.round(parseInt(data[3]) - ires) +' mosmol/L':'Beräknad osm: '+ Math.round(ires) +' mosmol/L<br>Fyll i osmolalitet för osmolgap.'),
			'calc[26]': result,
			'calc[27]': 'Korrigerat: '+ires+' ml på 24h.<br>('+(ires/2)+' ml på 8h, sedan '+(ires/2)+' ml på 16h)',
			'calc[28]': data.length==8?'Risken för lungemboli är under 2%.':'Alla kriterier är inte uppfyllda.',
			'calc[29]': result,
			'calc[30]': data.length>0?'Poäng: '+data.length+'. Hög risk för allvarlig händelse.':'Poäng: '+data.length+'. Låg risk för allvarlig händelse.',
			'calc[31]': 'Räcker  '+Math.round(parseInt(data[0]) * parseInt(data[1]) / parseInt(data[2]))+' minuter.',
			'calc[32]': result,
			'calc[33]': result,
			'calc[34]': result,
			'calc[35]': result,
			'calc[36]': result,
			'calc[37]': result,
			'calc[38]': result,
			'calc[39]': result,
			'calc[40]': result,
			'calc[41]': 'Poäng: '+data.length+(data.length>2?'.<br>Hög blödningsrisk.':'.<br>Lägre blödningsrisk.'),
			'calc[42]': result,
			'calc[43]': Math.round(20 * parseFloat(data[0]) * 1000 / 60 / parseFloat(data[1])) +' droppar per minut.',
			'calc[44]': 'Volymen blir ' + round((parseFloat(data[0]) * parseInt(data[1]) * 60) / 20000,ires) + ' liter.',
			'calc[45]': result,
		};
		return formulas[id];
	}
	function mapData(id,data) {
		let result ='';
		if(id == 'calc[7]') {
			let diagnoses = ['Keratit','Konjunktivit','Irit','Glaskroppsavlossning','Näthinneavlossning','Makuladegeneration','Glaukom'],
				source = {};
			source[id+'[0]'] = [diagnoses[0],diagnoses[1],diagnoses[2],diagnoses[6]];
			source[id+'[1]'] = [diagnoses[0]];
			source[id+'[2]'] = [diagnoses[0],diagnoses[2]];
			source[id+'[3]'] = [diagnoses[1]];
			source[id+'[4]'] = [diagnoses[1]];
			source[id+'[5]'] = [diagnoses[0],diagnoses[2],diagnoses[6]];
			source[id+'[6]'] = [diagnoses[2],diagnoses[3],diagnoses[4]];
			source[id+'[7]'] = [diagnoses[3],diagnoses[4]];
			source[id+'[8]'] = [diagnoses[4]];
			source[id+'[9]'] = [diagnoses[5]];
			source[id+'[10]'] = [diagnoses[6]];
			let matches = {},
				res_diagnoses = [];
			for (let i=0;i<data.length;i++) {
				let newarr = source[data[i]];
				for (let a=0;a<newarr.length;a++) {
					if(res_diagnoses.indexOf(newarr[a]) !== -1) {
						if(matches.hasOwnProperty(newarr[a]))
							matches[newarr[a]]++;
					} else {
						matches[newarr[a]] = 1;
					}
				}
				res_diagnoses = [...new Set([...res_diagnoses ,...source[data[i]]])];
			}
			let sortedArr = Object.entries(matches).sort(([, v1], [, v2]) => v2 - v1),
				sorted = Object.fromEntries(sortedArr),
				max = Math.max(...Object.values(sorted)),
				bullet = 1,
				counter = 0;
			result = bullet + '. ';
			for(let prop in sorted) {
				if(max === sorted[prop]) {
					result += (counter == 0 ? '':', ')+prop;
				} else {
					bullet++;
					max = sorted[prop];
					result += '<br>'+bullet + '. ' +prop;
				}
				counter++;
			}
			for (let i=0;i<res_diagnoses.length;i++) {
				let index = diagnoses.indexOf(res_diagnoses[i]);
				if(index !== -1)
					diagnoses.splice(index, 1);
			}
			if(diagnoses.length > 0) {
				result += '<br>'+(bullet+1)+'. ';
				for (let i=0;i<diagnoses.length;i++) {
					result += diagnoses[i] + (i == diagnoses.length-1 ? '' : ', ');
				}
			}
		}
		if(id == 'calc[9]') {
			result = 'Poäng: '+data.length+'<br>';
			if(data.length === 1)
				result += 'Sjukhusvård eller öppenvård med uppföljning.';
			if (data.length === 2)
				result += 'Sjukhusvård som regel.';
			if (data.length > 2)
				result += 'Sjukhusvård, överväg IVA.';
		}
		if(id == 'calc[11]') {
			let points = 0,
				risk1 = 0,
				risk2 = 0;
			if(parseInt(data[0]) >= 60)
				points++;
			if(parseInt(data[1]) >= 140 || parseInt(data[2]) >= 90)
				points++;
			if(parseInt(data[3]) >= 10 && parseInt(data[3]) < 60)
				points++;
			else if(parseInt(data[3]) > 59)
				points += 2;
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[5]' || data[i] == id+'[6]')
					risk2++;
				else if (data[i] == id+'[4]')
					risk1++;
			}
			if(risk2 < 2 && risk1 > 0) {
				risk1++;
				if(risk2 > 0)
					risk2 = 1;
			}
			points += risk1 + risk2;
			result = 'Poäng: '+points+'<br>';
			if(points < 4)
				result += '2-dagars strokerisk 1%.';
			else if(points > 3 && points < 6)
				result += '2-dagars strokerisk 4%.';
			else if(points > 5)
				result += '2-dagars strokerisk 8%.';
		}
		if(id == 'calc[12]') {
			let points = 0,
				risk = [0,1.3,2.2,3.2,4.0,6.7,9.6,9.8,10,15.2],
				women = '',
				source = {};
			source[id+'[1]'] = 1;
			source[id+'[2]'] = 1;
			source[id+'[3]'] = 2;
			source[id+'[4]'] = 1;
			source[id+'[5]'] = 1;
			source[id+'[6]'] = 1;
			if(parseInt(data[0]) > 64 && parseInt(data[0]) < 75)
				points++;
			else if(parseInt(data[0]) > 74)
				points += 2;
			for (let i=0;i<data.length;i++) {
				if(data[i] in source)
					points += source[data[i]];
				if(data[i] == 'calc[12][6]')
					women = ' (om poäng endast för kvinnligt kön rekommenderas ofta ingen behandling)';
			}
			result = 'Poäng: '+points+'<br>Förslag: ';
			if(points == 0)
				result += 'Ingen behandling.<br>Risk: 0%';
			else
				result += 'Waran eller NOAC'+women+'.<br>Risk: '+risk[points]+'%';
		}
		if(id == 'calc[13]') {
			let	total = 0,
				resting = 0,
				synkinesis = 0,
				arr_total = [id+'[3]',id+'[4]',id+'[5]',id+'[6]',id+'[7]'],
				arr_resting = [id+'[0]',id+'[1]',id+'[2]'],
				arr_synkinesis = [id+'[8]',id+'[9]',id+'[10]',id+'[11]',id+'[12]'];
			for (let i=0;i<data.length;i++) {
				if(arr_resting.includes(data[i]['name']))
					resting += parseInt(data[i]['value']);
				if(arr_synkinesis.includes(data[i]['name']))
					synkinesis += parseInt(data[i]['value']);
				if(arr_total.includes(data[i]['name']))
					total += parseInt(data[i]['value']);
			}
			result = total - resting - synkinesis;
		}
		if(id == 'calc[16]') {
			let total = 0;
			result = '';
			for (let i=0;i<data.length;i++) {
				total += parseInt(data[i]['value']);
			}
			result = total+'. ';
			if(total > 0 && total < 10) {
				result += 'Mycket lätt alkoholabstinens.';
			} else if(total > 9 && total < 16 ) {
				result += 'Lätt alkoholabstinens.';
			} else if(total > 15 && total < 21 ) {
				result += 'Måttlig alkoholabstinens.';
			} else if(total > 20) {
				result += 'Svår alkoholabstinens.';
			}
		}
		if(id == 'calc[18]') {
			let	total = 0;
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[9]')
					total -= 2;
				else
					total++;
			}
			result = 'Poäng: ' + total + '. Låg sannolikhet.';
			if(total > 1)
				result = 'Poäng: ' + total + '. Hög sannolikhet.';
		}
		if(id == 'calc[19]') {
			let total = 0;
			for (let i=0;i<data.length;i++) {
				total += parseInt(data[i]['value']);
			}
			result = 'GCS poäng: ' + total;
			if(total > 0 && total < 9)
				result += '.<br>Svår skada.';
			else if(total > 8 && total < 13)
				result += '.<br>Medelsvår skada.';
			else if(total > 12)
				result += '.<br>Lindrig skada.';
		}
		if(id == 'calc[21]') {
			let	total = 0,
				arr_one = [id+'[2]',id+'[5]'],
				arr_onefive = [id+'[1]',id+'[3]',id+'[4]'],
				arr_three = [id+'[0]',id+'[6]'];
			for (let i=0;i<data.length;i++) {
				if(arr_one.includes(data[i]))
					total++;
				if(arr_onefive.includes(data[i]))
					total += 1.5;
				if(arr_three.includes(data[i]))
					total += 3;
			}
			result = 'Poäng: ' + total + '. Låg sannolikhet.';
			if(total > 4)
				result = 'Poäng: ' + total + '. Hög sannolikhet.';
		}
		if(id == 'calc[23]') {
			let total = 0;
			for (let i=0;i<data.length;i++) {
				if(typeof data[i] === 'object' && data[i].hasOwnProperty('value'))
					total += parseInt(data[i]['value']);
			}
			result = 'NEWS poäng: '+total;
		}
		if(id == 'calc[26]') {
			let	risk = 0;
			result = 'Röntgen av fotleden ej nödvändig.';
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[3]' || data[i] == id+'[4]' || data[i] == id+'[5]')
					risk = 1;
			}
			if(risk == 1 || data.length > 2)
				result = 'Röntgen av fotleden rekommenderas.';
		}
		if(id == 'calc[29]') {
			let clinic = 0,
				common = 0,
				fixed = parseFloat(data[0]) >= 3 ? (parseFloat(data[0]) >= 280 ? (parseFloat(data[0]) >= 100 ? 1:2):3) : 4,
				convert = 4.608;
			if(parseInt(data[1]['value']) == 2) {
				clinic = parseFloat(data[0]) * 0.046 / 1.055;
				common = parseFloat(data[0]) * 0.046 / 1.055;
				if(parseInt(data[2]['value']) == 1) {
					clinic = parseFloat(clinic / convert).toFixed(fixed+1);
					common = parseFloat(common / convert).toFixed(fixed+1);
				} else {
					clinic = parseFloat(clinic).toFixed(fixed);
					common = parseFloat(common).toFixed(fixed);
				}
			} else {
				clinic = parseFloat(data[0]) / 1.16 * 0.046 / 1.055;
				common = parseFloat(data[0]) / 1.2 * 0.046 / 1.055;
				if(parseInt(data[2]['value']) == 1) {
					clinic = parseFloat(clinic / convert).toFixed(fixed+1);
					common = parseFloat(common / convert).toFixed(fixed+1);
				} else {
					clinic = parseFloat(clinic).toFixed(fixed);
					common = parseFloat(common).toFixed(fixed);
				}
			}
			result = 'Klinik: '+clinic+'‰<br>Rättsligt: '+common+'‰'
		}
		if(id == 'calc[32]') {
			let	total = 0;
			for (let i=0;i<data.length;i++) {
				if((data[i] == id+'[0]' || data[i] == id+'[1]' || data[i] == id+'[3]') && typeof data[i] !== 'object' && !data[i].hasOwnProperty('name'))
					total++;
				if(typeof data[i] === 'object' && data[i].hasOwnProperty('name') && data[i]['name'] == id+'[2]')
					total += parseInt(data[i]['value']);
			}
			if(parseFloat(data[4]) >= 0.70 && parseFloat(data[4]) < 0.85)
				total++;
			else if(parseFloat(data[4]) >= 0.85)
				total += 2;
			if(parseFloat(data[5]) >= 10 && parseFloat(data[5]) < 15)
				total++;
			else if(parseFloat(data[5]) >= 15)
				total += 2;
			if(parseFloat(data[6]) >=10 && parseFloat(data[6]) < 50)
				total++;
			else if(parseFloat(data[6]) >= 50)
				total += 2;
			result = 'Poäng: ' + total;
			if(total < 5)
				result += '<br>Låg sannolikhet.<br>Poliklinisk uppföljning om AT ua.';
			else if(total > 4 && total < 9)
				result += '<br>Intermediär sannolikhet.<br>Observation och utredning inneliggande.';
			else if(total > 8)
				result += '<br>Hög sannolikhet.<br>Exploration rekommenderas.';
		}
		if(id == 'calc[33]') {
			let	total = 0;
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[0]' || data[i] == id+'[6]')
					total += 2;
				else
					total++;
			}
			result = 'Poäng: ' + total;
			if(total < 4)
				result += '<br>Låg sannolikhet.';
			else if(total > 3 && total < 7)
				result += '<br>Intermediär sannolikhet.';
			else if(total > 6)
				result += '<br>Hög sannolikhet.';
		}
		if(id == 'calc[34]') {
			let	total = 0,
				gender = 0;
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[6]' || data[i] == id+'[7]' || data[i] == id+'[8]')
					total += 2;
				else if(data[i] == id+'[5]')
					total++;
				else if(data[i] == id+'[4]')
					gender = 1;
			}
			if(parseInt(data[0]) < 100)
				total += 6;
			if(gender === 0) {
				if(parseInt(data[0]) >= 100 && parseInt(data[0]) < 120)
					total += 3;
				if(parseInt(data[0]) >= 120 && parseInt(data[0]) < 130)
					total += 1;
			} else {
				if(parseInt(data[0]) >= 100 && parseInt(data[0]) < 120)
					total += 1;
			}
			if(parseFloat(data[1]) > 25)
				total += 6;
			else if (parseFloat(data[1]) >= 10 && parseFloat(data[1]) <= 25)
				total += 4;
			else if (parseFloat(data[1]) >= 8 && parseFloat(data[1]) < 10)
				total += 3;
			else if (parseFloat(data[1]) >= 6.5 && parseFloat(data[1]) < 8)
				total += 2;
			if(parseInt(data[2]) < 90)
				total += 3;
			else if (parseInt(data[2]) >= 90 && parseInt(data[2]) < 100)
				total += 2;
			else if (parseInt(data[2]) >= 100 && parseInt(data[2]) < 110)
				total++;
			if(parseInt(data[3]) >= 100)
				total++;
			result = 'Poäng: ' + total;
		}
		if(id == 'calc[35]') {
			let	total = 0,
				pbc = 0;
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[5]')
					pbc = 1;
				else if(typeof data[i] === 'object' && data[i].hasOwnProperty('value'))
					total += parseInt(data[i]['value']);
			}
			if((parseInt(data[0]) < 35 && pbc == 0) || (parseInt(data[0]) < 68 && pbc == 1))
				total++;
			else if((parseInt(data[0]) >= 35 && parseInt(data[0]) <= 51 && pbc == 0) || (parseInt(data[0]) >= 68 && parseInt(data[0]) <= 171 && pbc == 1))
				total += 2;
			else if((parseInt(data[0]) > 51 && pbc == 0) || (parseInt(data[0]) > 171 && pbc == 1))
				total += 3;
			if(parseInt(data[1]) > 35)
				total++;
			else if(parseInt(data[1]) >= 28 && parseInt(data[1]) <= 35)
				total += 2;
			else if(parseInt(data[1]) < 28)
				total += 3;
			if(parseFloat(data[2]) < 1.7)
				total++;
			else if(parseFloat(data[2]) >= 1.7 && parseFloat(data[2]) <= 2.3)
				total += 2;
			else if(parseFloat(data[2]) > 2.3)
				total += 3;
			result = 'Poäng: ' + total;
			if(total < 7)
				result += '<br>Chid-Pugh klass A.';
			else if(total > 6 && total < 10)
				result += '<br>Chid-Pugh klass B.';
			else if(total > 9)
				result += '<br>Chid-Pugh klass C.';
		}
		if(id == 'calc[36]') {
			let total = 0,
				age = parseInt(data[0]),
				sk = parseInt(data[1]),
				rd = 0,
				lvf = parseFloat(data[4]['value']),
				age_e = 0.0285181,
				weight = parseInt(data[2]),
				gender = parseInt(data[3]['value']) == 1 ? 0.2196434 : 0;
			if(age >= 60)
				age_e = (age-59) * age_e;
			else
				age_e = 1 * age_e;
			total += age_e + gender + lvf;
			total += parseFloat(data[5]['value']) + parseFloat(data[6]['value']) + parseFloat(data[7]['value']) + parseFloat(data[8]['value']);
			if(gender == 0) {
				rd = ((140 - age) * weight * 1.23) / sk;
			} else {
				rd = ((140 - age) * weight * 1.04) / sk;
			}
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[9]') {
					total += 0.3542749;
				} else if(data[i] == id+'[10]') {
					total += 0.1886564;
				} else if(data[i] == id+'[11]') {
					total += 0.5360268;
				} else if(data[i] == id+'[12]') {
					total += 0.2407181;
				} else if(data[i] == id+'[13]') {
					total += 1.118599;
				} else if(data[i] == id+'[14]') {
					total += 0.6194522;
				} else if(data[i] == id+'[15]') {
					total += 1.086517;
				} else if(data[i] == id+'[16]') {
					total += 0.2226147;
				} else if(data[i] == id+'[17]') {
					total += 0.1528943;
				} else if(data[i] == id+'[18]') {
					total += 0.6527205;
				} else if(data[i] == id+'[19]') {
					total += 0.6421508;
					rd = 100;
				}
			}
			if(rd <= 50)
				total += 0.8592256;
			else if(rd > 50 && rd <= 85)
				total += 0.303553;
			total += -5.324537;
			result = 'Mortalitet: '+ round((Math.pow(2.71828,total)/(1+Math.pow(2.71828,total)))*100,2) + '%.';
		}
		if(id == 'calc[37]') {
			let	smoker = 0,
				man = 0,
				risk = '',
				source = {},
				age = parseInt(data[0]),
				sbp = parseInt(data[1]),
				chol = parseFloat(data[2]) - parseFloat(data[3]);
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[4]')
					smoker = 1;
				else if(data[i] == id+'[5]')
					man = 1;
			}
			if (age >= 80) {
				result = '10-års risk: ≥ 15%.';
			} else {
				if(man == 0 && smoker == 0) {
					source = points_w_ns;
				} else if(man == 0 && smoker == 1) {
					source = points_w_s;
				} else if(man == 1 && smoker == 0) {
					source = points_m_ns;
				} else if(man == 1 && smoker == 1) {
					source = points_m_s;
				}
				for (let i=0;i<source.length;i++) {
					let data_age = source[i]['age']
					if(age >= data_age['min'] && age <= data_age['max']) {
						for (let l=0;l<data_age['options'].length;l++) {
							let data_sbp = data_age['options'][l]['sbp'];
							if((sbp >= data_sbp['min'] && sbp <= data_sbp['max'] && data_sbp['max'] > 0) || (sbp >= data_sbp['min'] && data_sbp['max'] < 0)) {
								for (let m=0;m<data_sbp['options'].length;m++) {
									let data_chol = data_sbp['options'][m]['chol'];
									if((chol >= data_chol['min'] && chol <= data_chol['max'] && data_chol['max'] > 0) || (chol >= data_chol['min'] && data_chol['max'] < 0)) {
										risk = data_sbp['options'][m]['risk'];
										break;
									}
								}
							}
						}
					}
				}
				result = '10-års risk: ';
				if(age < 50) {
					if(risk == 'g')
						result += '< 2.5%.';
					else if (risk == 'o')
						result += '≥ 2.5% och < 7.5%.';
					else if (risk == 'r')
						result += '≥ 7.5%.';
				} else if (age >= 50 && age < 70) {
					if(risk == 'g')
						result += '< 5%.';
					else if (risk == 'o')
						result += '≥ 5% och < 10%.';
					else if (risk == 'r')
						result += '≥ 10%.';
				} else if (age >= 70) {
					if(risk == 'g')
						result += '< 7.5%.';
					else if (risk == 'o')
						result += '≥ 7.5% och < 15%.';
					else if (risk == 'r')
						result += '≥ 15%.';
				}
			}
		}
		if(id == 'calc[38]') {
			let total = 0,
				risk = 0,
				mortality = [1.2,1.2,1.0,1.7,2.5,5.6,6.5,6.5],
				infarkt = [2.3,2.3,2.1,3.7,5.0,8.5,15.8,15.8],
				akut = [1.2,1.2,6.0,9.5,12.2,14.3,20.9,20.9];
			if(parseInt(data[0]) > 64)
				total++;
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[6]' || data[i] == id+'[7]' || data[i] == id+'[8]' || data[i] == id+'[9]' || data[i] == id+'[10]')
					total++;
				else if(data[i] == id+'[1]' || data[i] == id+'[2]' || data[i] == id+'[3]' || data[i] == id+'[4]' || data[i] == id+'[5]')
					risk++;
			}
			total += risk > 2 ? 1:0;
			result = 'TIMI poäng: '+ total + '.<br>Mortalitet 14 d: ' +mortality[total] + '%.<br>Hjärtinfarkt 14 d: '+infarkt[total] + '%.<br>Revaskularisering 14 d: ' +akut[total] + '%.';
		}
		if(id == 'calc[39]') {
			let total = 0,
				risk1 = 0,
				risk2 = 0,
				mortality = [0.8,1.6,2.2,4.4,7.3,12.4,16.1,23.4,26.8];
			if(parseInt(data[0]) > 64 && parseInt(data[0]) < 75)
				total += 2;
			else if (parseInt(data[0]) > 74)
				total += 3;
			if(parseInt(data[1]) < 100)
				total += 3;
			if(parseInt(data[2]) > 100)
				total += 2;
			if(parseInt(data[3]) < 67)
				total += 1;
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[7]')
					total += 2;
				else if(data[i] == id+'[4]' || data[i] == id+'[5]' || data[i] == id+'[6]')
					risk1 = 1;
				else if(data[i] == id+'[8]' || data[i] == id+'[9]')
					risk2 = 1;
				else if(data[i] == id+'[10]')
					total++;
			}
			total += risk1 + risk2;
			result = 'TIMI poäng: ' + total + '.<br>30-dagarsmortalitet: ' + (total > 8 ? 35.9:mortality[total]) + '%.';
		}
		if(id == 'calc[40]') {
			let rr = 60000 / parseInt(data[1]),
				qtc = round(parseInt(data[0]) / Math.pow(rr / 1000,1/2),3) + ' ms';
			if(2 in data) {
				result = 'Bazett: ' + qtc;
				result += '<br>Fridericia: ' + round(parseInt(data[0]) / Math.pow(rr / 1000,1/3),3) + ' ms';
				result += '<br>Framingham: ' + round(parseInt(data[0]) + 0.154 * (1000 - rr),3) + ' ms';
				result += '<br>Hodges: ' + round(parseInt(data[0]) + 1.75 * (60000 / rr - 60),3) + ' ms';
			} else {
				result = 'QTc: ' + qtc;
			}
		}
		if(id == 'calc[42]') {
			let yta = 0;
			if(typeof data[3] === 'object' && data[3].hasOwnProperty('value')) {
				if(parseInt(data[3]['value']) == 0)
					yta = round(Math.pow(parseInt(data[1]),0.425) * Math.pow(parseInt(data[0]),0.725) * 0.007184,5);
				else if (parseInt(data[3]['value']) == 1)
					yta = round(Math.pow(((parseInt(data[1]) * parseInt(data[0]))/3600),0.5),4);
				else if (parseInt(data[3]['value']) == 2)
					yta = round(0.024265 * Math.pow(parseInt(data[1]),0.5378) * Math.pow(parseInt(data[0]),0.3964),4);
			}
			result = 'Dos: ' + round(parseFloat(data[2]) * yta,6);
			result += '<br>Yta: ' + yta;
		}
		if(id == 'calc[45]') {
			let total = 4;
			for (let i=0;i<data.length;i++) {
				if(data[i] == id+'[1]' || data[i] == id+'[2]' || data[i] == id+'[3]' || data[i] == id+'[4]')
					total -= 1;
				else
					total += parseInt(data[i]['value']);
			}
			result += 'Poäng: ' + total+'.';
		}
		return result;
	}

	/* PECARN */
	$(document).on('change', '.form-pecarn select', function (e) {
		if(!localize_calc.logged_in) {
			$('.not_logged').show();
			return;
		}
		$('.not_logged').hide();
		checkResult();
	});
	let checkResult = function () {
		let val_1 = parseInt($('.form-pecarn select[name$="[0]"]').val()),
			val_2 = parseInt($('.form-pecarn select[name$="[1]"]').val()),
			val_3 = parseInt($('.form-pecarn select[name$="[2]"]').val()),
			val_4 = parseInt($('.form-pecarn select[name$="[3]"]').val()),
			val_5 = parseInt($('.form-pecarn select[name$="[4]"]').val()),
			$block_1 = $('.form-pecarn .block-1'),
			$block_2 = $('.form-pecarn .block-2'),
			$block_3 = $('.form-pecarn .block-3'),
			$result = $('.calc-result');
		if (val_1 == 1) {
			if (val_2 == 1) {
				$('.form-pecarn .block-3').removeClass('active');
				$block_1.addClass('active');
				if (val_3 == 1) {
					$result.html(localize_calc.pecarn_1);
					$block_2.removeClass('active');
				} else if (val_3 == 2) {
					$result.html('');
					$block_2.addClass('active');
					if (val_4 == 1) {
						$result.html(localize_calc.pecarn_3);
					} else if (val_4 == 2) {
						$result.html(localize_calc.pecarn_2);
					} else {
						$result.html('');
					}
				} else {
					$result.html('');
					$block_2.removeClass('active');
				}
			} else if (val_2 == 2) {
				$block_2.removeClass('active');
				$block_1.addClass('active');
				if (val_3 == 1) {
					$result.html(localize_calc.pecarn_1);
					$block_3.removeClass('active');
				} else if (val_3 == 2) {
					$result.html('');
					$block_3.addClass('active');
					if (val_5 == 1) {
						$result.html(localize_calc.pecarn_3);
					} else if (val_5 == 2) {
						$result.html(localize_calc.pecarn_2);
					} else {
						$result.html('');
					}
				} else {
					$result.html('');
					$block_3.removeClass('active');
				}
			} else {
				$block_1.removeClass('active');
				$block_2.removeClass('active');
				$block_3.removeClass('active');
				$result.html('');
			}
		} else {
			$block_1.removeClass('active');
			$block_2.removeClass('active');
			$block_3.removeClass('active');
			if (val_1 == 2)
				$result.html(localize_calc.pecarn_0);
			else
				$result.html('');
		}
	}

	let points_w_ns = [
		{'age': {'min': 0,'max': 44,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'g'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'g'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'g'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				}
			]}
		},
		{'age': {'min': 45,'max': 49,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'g'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'g'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				}
			]}
		},
		{'age': {'min': 50,'max': 54,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'g'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'g'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'g'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				}
			]}
		},
		{'age': {'min': 55,'max': 59,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'g'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'g'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				}
			]}
		},
		{'age': {'min': 60,'max': 64,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				}
			]}
		},
		{'age': {'min': 65,'max': 69,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 70,'max': 74,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 75,'max': 79,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		}
	],
	points_w_s = [
		{'age': {'min': 0,'max': 44,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				}
			]}
		},
		{'age': {'min': 45,'max': 49,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 50,'max': 54,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 55,'max': 59,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 60,'max': 64,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 65,'max': 69,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 70,'max': 74,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 75,'max': 79,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		}
	],
	points_m_ns = [
		{'age': {'min': 0,'max': 44,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				}
			]}
		},
		{'age': {'min': 45,'max': 49,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 50,'max': 54,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'g'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'g'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 55,'max': 59,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'g'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 60,'max': 64,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 65,'max': 69,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 70,'max': 74,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 75,'max': 79,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		}
	],
	points_m_s = [
		{'age': {'min': 0,'max': 44,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 45,'max': 49,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 50,'max': 54,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'o'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 55,'max': 59,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'o'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'o'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 60,'max': 64,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'o'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 65,'max': 69,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 70,'max': 74,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		},
		{'age': {'min': 75,'max': 79,
			'options': [
				{'sbp': {'min': 0,'max': 119,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 120,'max': 139,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 140,'max': 159,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				},
				{'sbp': {'min': 160,'max': -1,
					'options': [
						{'chol': {'min': 0,'max': 3.9}, 'risk': 'r'},
						{'chol': {'min': 4,'max': 4.9}, 'risk': 'r'},
						{'chol': {'min': 5,'max': 5.9}, 'risk': 'r'},
						{'chol': {'min': 6,'max': -1}, 'risk': 'r'},
					]}
				}
			]}
		}
	];
});
